<template>
  <div class="main">
    <!-- FIRST COLUMN -->
    <div class="card">
      <!-- <br> -->
      <v-layout row wrap class="buttons">
        <router-link to="/Riego">
          <div class="items">
            <v-btn
              round
              class="item"
              flat
              block
              v-if="$store.state.isUserLoggedIn"
              >REPORTES RIEGO</v-btn
            >
          </div>
        </router-link>
      </v-layout>
    </div>
    <br />
  </div>
</template>

<script>
export default {
  name: "Dashboard",
  data() {
    return {};
  },
  created() {},
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
.main {
  height: 500px !important;
}

.card {
  height: 450px;
  margin-left: 5%;
  width: 90%;
  padding: 40px !important;
}

.item {
  display: block;
  font-size: 20px;
  color: white !important;
  background-color: lightgray !important;
  margin-left: 220% !important;
  // width: 100% !important;
  // padding: 20 20 20 20 !important;
}

.buttons {
  margin-top: 10%;
}
</style>
